export const MARKET_CELL_WIDTH_MOBILE = 60;
export const MARKET_CELL_WIDTH_DESKTOP = 140;
export const MARKET_CELL_HEIGHT = 50;

export const MARKET_DOCK_HEIGHT = 64;
export const MARKET_DOCK_OFFSET = 24;
